import { createFileRoute, redirect } from "@tanstack/react-router";
import { toast } from "sonner";
import { auth } from "@/lib/auth";
import { useAuthStore } from "@/stores/useAuthStore";
import { ensureMyPermissions } from "@/hooks/api/authorization/useAuthorization";
import { hasAnyCapability } from "@/lib/permissions";

export const Route = createFileRoute("/(auth)/login")({
  beforeLoad: async () => {
    const token = auth.getToken();
    if (token) {
      const result = await useAuthStore.getState().getProfile();
      if (result.success) {
        // Same rule as the admin shell's guard: any capability beyond the
        // baseline reaches it.
        const capabilities = await ensureMyPermissions();
        throw redirect({
          to: hasAnyCapability(capabilities) ? "/admin" : "/user",
        });
      }
      // Drop the session locally only. A profile failure here is a 5xx, a
      // timeout, or a 401 whose refresh got no verdict -- the session may be
      // alive, and auth/logout/ would revoke it for every tab. A refresh that
      // did end the session already sent this tab to /logout?expired (T-234).
      useAuthStore.getState().logout({ endServerSession: false });
      if (result.serverUnavailable) {
        toast.error(
          "Couldn't reach the server to restore your session. Sign in again, or reload in a moment.",
          { id: "session-unavailable" },
        );
      }
    }
  },
  component: LoginPage,
});

import { LoginForm } from "@/components/login-form";

function LoginPage() {
  return (
    <div className="flex min-h-svh flex-col items-center justify-center bg-muted p-6 md:p-10">
      <div className="w-full max-w-sm md:max-w-3xl">
        <LoginForm />
      </div>
    </div>
  );
}
